<template>
  <div>
    <v-checkbox
      v-if="desplayShowToCostomerBtn"
      v-model="data.visibleToCustomer"
      label="Synlig for kunde"
      :ripple="false"
      hide-details
    ></v-checkbox>
    <v-alert v-if="desplayShowToCostomerBtn" class="mt-2" color="info" text>
      For at kunde skal bli varslet om kommentaren per mail og se kommentaren i
      Mitt Trysilhus, må synlig for kunde hukes av.
    </v-alert>

    <MetionTextArea
      class="mb-4"
      v-model="selectedTemplet"
      :closeDialog="closeDialog"
      :tagUsers="tagUsers"
      @updateComment="updateComment"
    />

    <FileDropzone
      v-model="data.attachments"
      ref="attachments"
      :disableClick="true"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";

import { valueTypeObject, CommentObject } from "@/types/commentInterface";
import { KeyValueExtra } from "@/types/keyValue";

import MetionTextArea from "@/components/shared/comments/MetionTextArea.vue";
import FileDropzone from "@/components/shared/attachments/FileDropzone.vue";

export default Vue.extend({
  name: "EditProfileDialog",
  props: {
    value: {
      type: Object as () => CommentObject,
    },
    closeDialog: {
      type: Boolean,
    },
    context: {
      type: Object as () => valueTypeObject,
    },
    desplayShowToCostomerBtn: {
      type: Boolean,
      default: false,
    },
    tagUsers: {
      type: Array as () => Array<KeyValueExtra>,
    },
  },
  data() {
    return {
      selectedTemplet: null as any,
    };
  },
  methods: {
    updateComment(data) {
      this.data.newComment = data.comment;
      this.data.tags = data.tags.map((x) => {
        return { personId: x, status: 1 };
      });
    },
  },

  computed: {
    data: {
      get(): CommentObject {
        return this.value;
      },
      set(value: CommentObject) {
        this.$emit("input", value);
      },
    },
  },

  components: {
    MetionTextArea,
    FileDropzone,
  },
});
</script>
